import { useSite } from "@/context/SiteContext";
import { EditableText } from "@/components/EditableText";
import { Reveal } from "@/components/Reveal";

const Footer = () => {
  const { setLoginOpen } = useSite();
  return (
    <footer data-testid="site-footer" className="bg-[#1A1713] text-[#F5F2EA]">
      <div className="mx-auto max-w-[1400px] px-6 pb-10 pt-24 md:px-12">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#F5F2EA]/50">
            Ethiopian &amp; Eritrean Cafe — Brixton, London
          </p>
          <h2
            className="mt-6 font-serif text-[clamp(3rem,12vw,10rem)] leading-none tracking-tight"
            data-testid="footer-brand"
          >
            Kal's <span className="italic text-[#F5F2EA]/60">Cafe</span>
          </h2>
        </Reveal>
        <div className="mt-16 flex flex-wrap items-end justify-between gap-6">
          <EditableText
            path="footer.tagline"
            testId="footer-tagline"
            className="font-serif text-xl italic text-[#F5F2EA]/70"
          />
          <p
            onDoubleClick={() => setLoginOpen(true)}
            className="cursor-default select-none text-xs text-[#F5F2EA]/40"
            data-testid="footer-copyright"
            title=""
          >
            © {new Date().getFullYear()} Kal's Cafe, Brixton. All rights reserved.
          </p>
        </div>
      </div>
      <div className="grid h-1 grid-cols-4" data-testid="footer-flag-strip" aria-hidden="true">
        <span className="bg-[#078930]" />
        <span className="bg-[#FCDD09]" />
        <span className="bg-[#DA121A]" />
        <span className="bg-[#0F47AF]" />
      </div>
    </footer>
  );
};

export default Footer;
